export enum QuestionContainerType {
    Container = 'container',
}
